import { ActivatedRoute, Router } from "@angular/router";
import { Component, OnInit } from "@angular/core";
import { AmplitudeService } from "../../services/amplitude.service";
import { AuthService } from "../../services/auth.service";
import { ReportService } from "../../services/report.service";
export {};
declare global {
	interface Window {
		Calendly: any;
	}
}

@Component({
	selector: "app-book-calendly",
	templateUrl: "./book-calendly.component.html",
	styleUrls: ["./book-calendly.component.scss"]
})
export class BookCalendlyComponent implements OnInit {
	reportUUIDV4?: string;
	report: any;

	constructor(
		private route: ActivatedRoute,
		private amplitudeService: AmplitudeService,
		private authService: AuthService,
		private reportService: ReportService,
		private router: Router
	) {
		if (this.route.snapshot.paramMap.keys.length) {
			if (this.route.snapshot.paramMap.has("reportUUIDV4"))
				this.reportUUIDV4 = this.route.snapshot.paramMap.get(
					"reportUUIDV4"
				) as string;
		}
	}

	ngOnInit(): void {
		this.getReport();
	}

	getReport() {
		this.reportService.get(this.reportUUIDV4!).subscribe((res: any) => {
			if (res.statusCode === 200) {
				if (res.authRequired) {
					if (res.isUserExist) {
						let url = this.router.url;
						this.authService.redirectToLogin({
							queryParams: { returnUrl: url, prefillEmailId: res.user.emailId },
							skipLocationChange: url ? true : false
						});
					} else {
						this.router.navigate(["user-sign-up"], { state: res });
					}
					return;
				}
				this.report = res.report;
				const calendlyLink =
					this.route.snapshot.queryParamMap.get("calendlyLink");
				window.Calendly.initInlineWidget({
					url: calendlyLink,
					parentElement: document.querySelector(".calendly-inline-widget")
				});

				this.amplitudeService.track("Purchased Session", {
					userId: this.authService.user.id,
					reportId: this.report.id
				});
			}
		});
	}
}
